import {
  compose,
  filter,
  lte,
  path,
} from 'ramda'

/**
 * Filters a list of cache items and removes any that are
 *
 * @param {Array<HttpCacheItem>} items
 * @param {Number} thresholdTimestamp
 * @return {Array<HttpCacheItem>}
 */
const expiredItemFilter = (thresholdTimestamp, items) => filter(
  compose(lte(thresholdTimestamp), path(['expiresOn'])),
  items,
)

export default expiredItemFilter
